import { render, staticRenderFns } from "./NonMedicalInfoTalentFind.vue?vue&type=template&id=5d4b4ce6"
import script from "./NonMedicalInfoTalentFind.vue?vue&type=script&lang=js"
export * from "./NonMedicalInfoTalentFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports